import { Flex } from "@100mslive/roomkit-react";

const MyOrgTop = () => {
  return (
    <Flex className="events6ix-layout-page-top">
      <h1 className="events6ix-layout-page-top-heading">My Orgs</h1>
    </Flex>
  );
};

export default MyOrgTop;
